export default __webpack_public_path__ + "static/media/0063.bdf88547.png";